<template lang="pug">
  ev-autocomplete(
    v-model="inputValue"
    :items="levels"
    label="Уровень"
    item-text="name"
    item-value="value"
    v-bind="$attrs"
  )
</template>

<script>
import listsService from '@/services/API/_lists';

export default {
  props: {
    value: { type: Number, default: null },
    limit: { type: Number, default: -1 },
  },
  data() {
    return {
      items: [],
    };
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    levels() {
      return this.items.filter((({ value }) => (value) > this.limit));
    },
  },
  created() {
    listsService.getAwardLevels().then((response) => {
      this.items = response.data.data;
    });
  },
};
</script>
